import React from 'react';
import home from '../../../assets/img/marker/current_location@2x.png';

import './style.css';


function HomeMarker() {

    return (
        <div className={'marker'} style={{ width: '10px', height: '10px', backgroundImage: `url(${home})` }}>
            {/* {text} */}
        </div>
    )

};

export default HomeMarker;